const getContentWidth = (windowSize) => {
    if (windowSize.width < 576) {
        return '100vw';
    }

    return windowSize.width <= 992 ? '75%' : '50%';
};

const PageShell = ({ children, windowSize, alignContent = 'center', contentClassName = '', contentStyle = {} }) => (
    <div
        className="d-flex flex-column justify-content-start align-items-center"
        style={{ minHeight: '100vh', minWidth: '350px', backgroundColor: '#0E94C3' }}
    >
        <div
            className={`card d-flex flex-column justify-content-${alignContent} align-items-center p-3 py-3 ${contentClassName}`}
            style={{
                minWidth: getContentWidth(windowSize),
                minHeight: '100vh',
                position: 'relative',
                ...contentStyle,
            }}
        >
            {children}
        </div>
    </div>
);

export default PageShell;
